module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/teenagers-2780a73150cda3a9c65f50ca2942c781.webp";